<template>
  <section class="sec sec-alt solution-sec" id="solutions">
    <div class="sec-inner">
      <div class="sec-head">
        <div class="sec-eyebrow">行业方案</div>
        <h2 class="sec-title">医疗与医保信息化解决方案</h2>
        <p class="sec-sub">
          {{ company.desc }}
        </p>
        <a class="company-link" :href="company.site" target="_blank" rel="noopener">
          {{ company.name }} &rarr;
        </a>
      </div>

      <!-- 公司数字 -->
      <div class="facts">
        <div class="fact" v-for="f in company.facts" :key="f.label">
          <div class="fact-value">{{ f.value }}</div>
          <div class="fact-label">{{ f.label }}</div>
        </div>
      </div>

      <!-- 可以点开看的方案 -->
      <div class="sol-grid">
        <a
          class="sol-card"
          v-for="s in solutions"
          :key="s.name"
          :href="s.demo"
          target="_blank"
          rel="noopener"
        >
          <div class="sol-top">
            <div class="sol-tagline">{{ s.tagline }}</div>
            <h3 class="sol-name">{{ s.name }}</h3>
          </div>
          <p class="sol-desc">{{ s.desc }}</p>
          <div class="sol-tags">
            <span v-for="t in s.tags" :key="t">{{ t }}</span>
          </div>
          <div class="sol-foot">在线演示 &rarr;</div>
        </a>
      </div>

      <!-- 没有演示页的产品线 -->
      <div class="others">
        <div class="others-head">同一条线上的其他平台</div>
        <div class="others-list">
          <div class="other" v-for="o in otherPlatforms" :key="o.name">
            <div class="other-name">{{ o.name }}</div>
            <div class="other-desc">{{ o.desc }}</div>
          </div>
        </div>
      </div>

      <!-- 资质与落地 -->
      <div class="proof">
        <div class="proof-col">
          <div class="proof-title">资质与获奖</div>
          <ul class="proof-list">
            <li v-for="h in company.honors" :key="h">{{ h }}</li>
          </ul>
        </div>
        <div class="proof-col">
          <div class="proof-title">落地区域</div>
          <div class="regions">
            <span v-for="r in company.regions" :key="r">{{ r }}</span>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { company, solutions, otherPlatforms } from "@/assets/js/profile";

export default {
  name: "SolutionSection",
  data() {
    return { company, solutions, otherPlatforms };
  }
};
</script>

<style scoped>
.sec-head {
  margin-bottom: 40px;
}
.company-link {
  display: inline-block;
  margin-top: 18px;
  font-size: 15px;
  font-weight: 500;
  color: var(--accent);
}
.company-link:hover {
  color: var(--accent-deep);
}

/* 公司数字 */
.facts {
  display: flex;
  flex-wrap: wrap;
  padding: 26px 0;
  border-top: 1px solid var(--border);
  border-bottom: 1px solid var(--border);
  margin-bottom: 44px;
}
.fact {
  flex: 1 1 160px;
  min-width: 130px;
  padding-right: 20px;
}
.fact-value {
  font-size: 30px;
  font-weight: 600;
  color: var(--ink);
  letter-spacing: -0.8px;
}
.fact-label {
  font-size: 13px;
  color: var(--ink-soft);
  margin-top: 5px;
}

/* 方案卡片 */
.sol-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 22px;
}
.sol-card {
  display: flex;
  flex-direction: column;
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  padding: 30px 28px 24px;
  transition: border-color 0.2s ease, transform 0.2s ease;
}
.sol-card:hover {
  border-color: var(--accent);
  transform: translateY(-2px);
}
.sol-tagline {
  font-size: 12.5px;
  letter-spacing: 1px;
  color: var(--accent);
  margin-bottom: 10px;
}
.sol-name {
  font-size: 21px;
  font-weight: 600;
  color: var(--ink);
  margin: 0 0 16px;
  letter-spacing: -0.3px;
}
.sol-desc {
  font-size: 14.5px;
  line-height: 1.95;
  color: var(--ink-soft);
  margin: 0 0 18px;
  flex: 1 1 auto;
}
.sol-tags {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 20px;
}
.sol-tags span {
  font-size: 12.5px;
  color: var(--ink-mid);
  background: var(--bg-alt);
  border-radius: 6px;
  padding: 4px 10px;
  margin: 0 7px 7px 0;
}
.sol-foot {
  padding-top: 16px;
  border-top: 1px solid var(--border-soft);
  font-size: 14px;
  font-weight: 500;
  color: var(--accent);
}

/* 其他平台 */
.others {
  margin-top: 52px;
}
.others-head {
  font-size: 13px;
  letter-spacing: 1.5px;
  color: var(--ink-faint);
  margin-bottom: 18px;
}
.others-list {
  display: grid;
  /* 四项，排成 2x2 才齐；260px 会挤成 3 列导致最后一行落单 */
  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
  gap: 0 34px;
  border-top: 1px solid var(--border);
}
.other {
  padding: 20px 0;
  border-bottom: 1px solid var(--border-soft);
}
.other-name {
  font-size: 15.5px;
  font-weight: 500;
  color: var(--ink);
  margin-bottom: 6px;
}
.other-desc {
  font-size: 13.5px;
  line-height: 1.85;
  color: var(--ink-soft);
}

/* 资质与落地 */
.proof {
  display: flex;
  flex-wrap: wrap;
  margin-top: 52px;
  padding-top: 34px;
  border-top: 1px solid var(--border);
}
.proof-col {
  flex: 1 1 340px;
  min-width: 280px;
  padding-right: 40px;
}
.proof-title {
  font-size: 13px;
  letter-spacing: 1.5px;
  color: var(--ink-faint);
  margin-bottom: 16px;
}
.proof-list {
  margin: 0;
  padding: 0;
  list-style: none;
}
.proof-list li {
  font-size: 14.5px;
  line-height: 1.9;
  color: var(--ink-mid);
  padding-left: 16px;
  position: relative;
  margin-bottom: 6px;
}
.proof-list li:before {
  content: "";
  position: absolute;
  left: 0;
  top: 12px;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: var(--accent);
}
.regions {
  display: flex;
  flex-wrap: wrap;
}
.regions span {
  font-size: 13px;
  color: var(--ink-mid);
  border: 1px solid var(--border);
  border-radius: 20px;
  padding: 5px 13px;
  margin: 0 8px 8px 0;
}

@media (max-width: 760px) {
  .fact-value {
    font-size: 24px;
  }
  .fact {
    flex: 1 1 45%;
    margin-bottom: 14px;
  }
  .proof-col {
    padding-right: 0;
    margin-bottom: 30px;
  }
}
</style>
